// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2gIve","header":"styles_header__HSoTf","mainContent":"styles_mainContent__9SSj4","footer":"styles_footer__23n8Y","version":"styles_version__3JpTq"};